import React, { useState } from "react";
import Cropper from "react-cropper";
import mergeImages from "merge-images";
import { Modal, Button } from "react-bootstrap";

import maskImg1 from "./assets/30Nov/mask.png";
import fileLogo from "./assets/30Nov/logo.png";
import btnImg from "./assets/26september/btn.png";

import logo from "./assets/logo.svg";
import facebook from "./assets/social/facebook.svg";
import youtube from "./assets/social/youtube.svg";
import twitter from "./assets/social/twitter.svg";
import instagram from "./assets/social/instagram.svg";
import downlaod from "./assets/download.png";

const CropperPage = () => {
  const [image, setImage] = useState();
  const [cropData, setCropData] = useState();
  const [cropper, setCropper] = useState();
  const [show, setShow] = useState(false);
  const [maskList, setMaskList] = useState([maskImg1]);
  const [selectedMask, setSelectedMask] = useState(0);

  const uploadFileHandler = (e) => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;

      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(files[0]);
    }
  };

  const getCropData = () => {
    if (typeof cropper !== "undefined") {
      const width = cropper.getCroppedCanvas().width;
      const height = cropper.getCroppedCanvas().height;

      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(document.querySelector("#maskImg"), 0, 0, width, height);

      console.log("cropperd", cropper.getCroppedCanvas());
      mergeImages([
        { src: cropper.getCroppedCanvas().toDataURL() },
        { src: canvas.toDataURL() },
      ]).then((result) => {
        setCropData(result);
        setShow(true);
      });
    }
  };

  console.log("maskList", cropData);

  const DownLoadHandler = () => {
    let link = document.createElement("a");
    link.download = "cover.jpeg";
    link.target = "_blank";
    link.href = cropData;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const clearHandler = () => {
    setImage(null);
    setCropData(null);
  };

  const selectMaskHandler = (i) => setSelectedMask(i);

  return (
    <div className="container-fluid main-editor">
      <div className="row">
        <div className="col-12 center-content mb-5 mt-3">
          <div className="">
            <a href="https://belqees.net/">
              <img src={logo} className="logo" />
            </a>
            <div className="d-block mx-auto">
              <ul className="icons">
                <li>
                  <a href="https://www.facebook.com/belqees.tv/">
                    <img src={facebook} alt="" />
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/channel/UCxA_zZwALQMmVMSZyLKC-Nw">
                    <img src={youtube} alt="" />
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/BelqeesTV">
                    <img src={twitter} alt="" />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/belqees.tv/">
                    <img src={instagram} alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="row revers-column">
        {image ? (
          <>
            <div className="col-lg-6 col-12 pt-3 pt-lg-0 center-content">
              {/*<ul className="masks-list">
                {maskList.map((mask, i) => (
                  <li key={i}>
                    <img src={mask} onClick={() => selectMaskHandler(i)} />
                  </li>
                ))}
              </ul>*/}
              <div className="preview-box">
                <h1 className="mb-3"> معاينة</h1>
                <div
                  className="preview-img"
                  style={{
                    width: selectedMask == 0 ? "300px" : "150px",
                    float: "left",
                    height: selectedMask == 0 ? "300px" : "150px",
                    position: "absolute",
                    bottom: 0,
                  }}
                />
                <img
                  id="maskImg"
                  src={maskList[selectedMask]}
                  className="mask-img"
                />
              </div>
            </div>
            <div className="col-lg-4 col-12  cr-co">
              <Cropper
                style={{ height: "100%" }}
                zoomTo={0}
                initialAspectRatio={1}
                aspectRatio={1 / 1}
                preview=".preview-img"
                src={image}
                viewMode={2}
                minCropBoxHeight={10}
                minCropBoxWidth={10}
                background={false}
                responsive={true}
                autoCropArea={1}
                onInitialized={(instance) => {
                  setCropper(instance);
                }}
                guides={true}
              />
            </div>
          </>
        ) : (
          <div className="pt-5">
            <div className="uploader-container">
              <label htmlFor="uploader-input" className="uploader">
                <img
                  src={fileLogo}
                  style={{
                    maxWidth: "800px",
                    maxHeight: "550px",
                    width: "100%",
                  }}
                />
                <div className="m-3 mt-5">
                  <img
                    src={btnImg}
                    className=""
                    style={{ maxWidth: "300px" }}
                  />
                </div>
              </label>
              <input
                id="uploader-input"
                type="file"
                accept="image/png, image/gif, image/jpeg"
                onChange={uploadFileHandler}
              />
            </div>
          </div>
        )}
      </div>
      <div className="row pb-3">
        {image ? (
          <div className="d-flex justify-content-center w-50 mx-auto">
            <button onClick={clearHandler} className="btn-approval btn-error">
              إلغاء
            </button>
            <button onClick={getCropData} className="btn-approval ms-3 ms-lg-0">
              تثبيت
            </button>
          </div>
        ) : null}
      </div>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Body>
          <img style={{ width: "100%" }} src={cropData} alt="cropped" />
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-between w-100">
            <Button
              className="btn-approval btn-error"
              onClick={() => setShow(false)}
            >
              إغلاق
            </Button>
            <button className="btn-approval btn-true" onClick={DownLoadHandler}>
              <img src={downlaod} className="download-icon" />
              تنزيل
            </button>
          </div>
          <div>
            ملاحظة : في حال واجهت مشكلة في التنزيل قم فتح الرابط من المتصفح{" "}
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CropperPage;
